module.exports = __webpack_public_path__ + "img/DSC_0034.81032d0e.jpg";